var _path, _path2, _path3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPh = function SvgPh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 180 90"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0038a8",
    d: "M0 0h180v90H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ce1126",
    d: "M0 45h180v45H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M77.942 45 0 90V0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fcd116",
    transform: "translate(28 45)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 9
  }), /*#__PURE__*/React.createElement("g", {
    id: "ph_svg__d"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ph_svg__c"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ph_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-19 0 1.178 1.178L0 0l-17.822-1.178z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ph_svg__a",
    d: "m-.884.116.05.05L0 0z",
    transform: "scale(19.2381)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ph_svg__a",
    transform: "scale(1 -1)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ph_svg__b",
    transform: "rotate(45)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ph_svg__c",
    transform: "rotate(90)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ph_svg__d",
    transform: "rotate(180)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2.02)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ph_svg__f",
    transform: "translate(37.962)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ph_svg__e",
    d: "M5 0 1.618 1.176l-.073 3.58-2.163-2.854-3.427 1.037L-2 0z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ph_svg__e",
    transform: "scale(1 -1)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ph_svg__f",
    transform: "rotate(120)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ph_svg__f",
    transform: "rotate(-120)"
  })))));
};
export default SvgPh;